/* ═══════════════════════════════════════════════════════════════
   Chat launcher.

   Opens and closes the panel, and nothing else — the three links
   inside it are plain anchors, so once the panel is open it works
   with script disabled. Escape closes, as does a click anywhere
   outside the widget, which is what a floating panel owes a
   touch user with no visible way back.

   Written against `document`, not a single node, so the theme
   editor re-rendering the footer group cannot leave a dead
   listener behind.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict'

  function panelOf(root) {
    return root.querySelector('[data-gmd-chat-panel]')
  }

  function setOpen(root, open) {
    var toggle = root.querySelector('[data-gmd-chat-toggle]')
    var panel = panelOf(root)
    if (!toggle || !panel) return

    panel.hidden = !open
    root.classList.toggle('is-open', open)
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false')

    var label = open ? toggle.dataset.labelClose : toggle.dataset.labelOpen
    if (label) toggle.setAttribute('aria-label', label)

    if (open) {
      var first = panel.querySelector('a[href]')
      if (first) first.focus()
    }
  }

  function closeAll(except) {
    document.querySelectorAll('[data-gmd-chat].is-open').forEach(function (root) {
      if (root !== except) setOpen(root, false)
    })
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-gmd-chat-toggle]')

    if (toggle) {
      var root = toggle.closest('[data-gmd-chat]')
      if (!root) return
      var open = toggle.getAttribute('aria-expanded') !== 'true'
      closeAll(root)
      setOpen(root, open)
      return
    }

    if (!event.target.closest('[data-gmd-chat]')) closeAll()
  })

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return

    var open = document.querySelector('[data-gmd-chat].is-open')
    if (!open) return

    setOpen(open, false)
    var toggle = open.querySelector('[data-gmd-chat-toggle]')
    if (toggle) toggle.focus()
  })
})()
